import React from 'react';
import Section from '../forms/section/Section';

const RecapStep = ({ formData, onModify, onConfirm, isSubmitting, error }) => {
  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  return (
    <div className="p-4">
      <h2 className="brand-title">Récapitulatif de votre réclamation</h2>

      <Section title="Informations personnelles">
        <div className="recap-section">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Civilité :</strong> {formData.civilite}</p>
              <p><strong>Prénom :</strong> {formData.prenom}</p>
              <p><strong>Nom :</strong> {formData.nom}</p>
              <p><strong>Email :</strong> {formData.email}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Téléphone :</strong> {formData.telephone}</p>
              <p><strong>Ville :</strong> {formData.ville}</p>
            </div>
          </div>
        </div>
      </Section>

      <Section title="Détails de la réclamation">
        <div className="recap-section">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Point de service :</strong> {formData.pointService}</p>
              <p><strong>Numéro de compte :</strong> {formData.numeroCompte}</p>
              <p><strong>Canal de Réponse :</strong> {formData.canalReponse}</p>
              <p><strong>Élément :</strong> {formData.element}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Catégorie :</strong> {formData.categorie}</p>
              <p><strong>Objet de la plainte :</strong> {formData.objetPlainte}</p>
              <p><strong>Date de l'incident :</strong> {formatDate(formData.dateIncident)}</p>
              {formData.lieuIncident && (
                <p><strong>Lieu de l'incident :</strong> {formData.lieuIncident}</p>
              )}
            </div>
          </div>

          {formData.montantReclame && (
            <div className="row mt-3">
              <div className="col-12">
                <p>
                  <strong>Montant réclamé :</strong>{' '}
                  {new Intl.NumberFormat('fr-FR').format(formData.montantReclame)}{' '}
                  {formData.devise}
                </p>
              </div>
            </div>
          )}

          <div className="row mt-3">
            <div className="col-12">
              <p><strong>Description :</strong></p>
              <p className="recap-description bg-light p-3 rounded">{formData.description}</p>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <p><strong>Attente :</strong></p>
              <p className="recap-description bg-light p-3 rounded">{formData.attente}</p>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <p>
                <strong>Relance d'une réclamation existante : </strong>
                {formData.isRelance === 'oui' ? 'Oui' : 'Non'}
              </p>
            </div>
          </div>

          {/* Informations de relance */}
          {formData.isRelance === 'oui' && (
            <div className="row mt-3">
              <div className="col-12">
                <div className="relance-recap p-3 border rounded bg-light">
                  <h5 className="mb-3">Informations sur la réclamation initiale</h5>
                  <p><strong>Date de la réclamation initiale :</strong> {formatDate(formData.dateReclamationInitiale)}</p>
                  <p><strong>Mode d'introduction de la réclamation initiale :</strong> {formData.modeIntroductionInitiale}</p>

                  {formData.modeIntroductionInitiale === 'En Agence' && formData.precisionAgence && (
                    <p><strong>Agence :</strong> {formData.precisionAgence}</p>
                  )}

                  {formData.modeIntroductionInitiale === "J'ai juste informé mon gestionnaire" && formData.nomGestionnaire && (
                    <p><strong>Nom du gestionnaire :</strong> {formData.nomGestionnaire}</p>
                  )}
                </div>
              </div>
            </div>
          )}

          {formData.files && formData.files.length > 0 && (
            <div className="row mt-3">
              <div className="col-12">
                <p><strong>Pièces jointes :</strong></p>
                <ul className="list-unstyled">
                  {formData.files.map((file, index) => (
                    <li key={index} className="ms-3">
                      {file.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </Section>

      {error && (
        <div className="alert alert-danger mt-3">
          {error}
        </div>
      )}

      <div className="d-flex justify-content-end gap-3 mt-4">
        <button
          className="secondary-button"
          onClick={onModify}
          disabled={isSubmitting}
        >
          Modifier
        </button>
        <button
          className="brand-button"
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Envoi en cours...
            </>
          ) : 'Confirmer'}
        </button>
      </div>
    </div>
  );
};

export default RecapStep;